/**
 * /practitioner-access — Client Consent Settings screen.
 *
 * Accessed from Settings via SettingsItem in the Privacy section.
 * Uses Expo Router Stack.Screen for native back gesture + header.
 */

import { Stack, useRouter } from 'expo-router';
import { useTranslation } from '@dramadetector/shared';
import { PractitionerAccessScreen } from '../components/screens/practitioner-consent';

export default function PractitionerAccessRoute() {
  const { t } = useTranslation('practitioner_consent');
  const router = useRouter();

  return (
    <>
      <Stack.Screen
        options={{
          title: t('screen.title'),
          headerBackTitle: '',
          presentation: 'card',
        }}
      />
      <PractitionerAccessScreen onBack={() => router.back()} />
    </>
  );
}
